import { AuthActions, AuthSelectors, LanguageSelectors } from '@web_opxp/features';
import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import { AppSelectors } from '../../app';
import { IState } from '../../store/state';
import HeaderWrapper from './HeaderWrapper';

export const mapStateToProps = (state: IState) => {
  const langLoading = LanguageSelectors.isLoading(state);
  const appLoading = AppSelectors.isAppLoading(state);
  const isPremium = AuthSelectors.isPremium(state);
  const session = AuthSelectors.getToken(state);
  const regular = AuthSelectors.getUnreadMessages(state);
  const friendship = AuthSelectors.getFriendRequests(state);
  const picture = AuthSelectors.getUserPicture(state);
  const authorized = AuthSelectors.isAuthorized(state);
  const alias = AuthSelectors.getUserEmail(state);
  const isLoggedIn = AuthSelectors.isLoggedIn(state);
  return {
    loading: langLoading || appLoading,
    isPremium,
    session,
    regular,
    friendship,
    picture,
    authorized,
    alias,
    isLoggedIn,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onUserMenuAction: (actionType: string) => dispatch({ type: actionType } as Action),
    onLogin: () => dispatch(AuthActions.redirectToSSO()),
  };
};

const HeaderWrapperConnected = connect(mapStateToProps, mapDispatchToProps)(HeaderWrapper);
export default HeaderWrapperConnected;
